angular.module('iconoglobe')
.service('cookieStore', [function(){
  var domain = ".iconoglobe.com";  
  this.setCookie = function(key, value){
    var d = new Date();
    var exdays = 30;
    d.setTime(d.getTime() + (30*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = key + "=" + value + ";" + expires + ";domain="+domain+";path=/";
  }
  this.setExpiryCookie = function(key, value, expires){
    var d = new Date();
    d.setTime(d.getTime() + (expires*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = key + "=" + value + ";" + expires + ";domain="+domain+";path=/";
  } 
  
  this.getCookie = function(name) {
//    console.log("document.cookie is ", document.cookie)
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
  }
}]);